<script>
    // import {user, doLogin, doLogout} from "../stores/user";
    import clickOutside from "../../../../../lib/svelte_click_outside";
    import {fadeScale} from "../../../../../lib/svelte_custom_transitions";
    import {cubicIn, cubicOut} from 'svelte/easing';
    // import {navigateTo} from "../stores/router";

    let show = false; // menu state

    const handleOutsideClick = e => {
        if(show) {
            show = false;
        }
    };
</script>


<!-- Profile dropdown -->
<div class="relative ml-3" use:clickOutside={handleOutsideClick}>
    <div>
        <button on:click={() => show = !show}
                type="button" class="flex rounded-full bg-gray-800 text-sm focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-gray-800" id="user-menu-button" aria-expanded="false" aria-haspopup="true">
            <span class="sr-only">Open user menu</span>
            <img class="h-8 w-8 rounded-full" src="https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=facearea&facepad=2&w=256&h=256&q=80" alt="">
        </button>
    </div>

    <!--
      Dropdown menu, show/hide based on menu state.

      Entering: "transition ease-out duration-200"
        From: "transform opacity-0 scale-95"
        To: "transform opacity-100 scale-100"
      Leaving: "transition ease-in duration-75"
        From: "transform opacity-100 scale-100"
        To: "transform opacity-0 scale-95"
    -->
    {#if show}
        <div in:fadeScale={{duration: 100, easing: cubicIn, base_scale: 0.75}}
             out:fadeScale={{duration: 100, easing:cubicOut, base_scale: 0.75}}
             class="absolute right-0 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none" role="menu" aria-orientation="vertical" aria-labelledby="user-menu-button" tabindex="-1">
            <!-- Active: "bg-gray-100", Not Active: "" -->
            <a href="/" class="block px-4 py-2 text-sm text-gray-700" role="menuitem" tabindex="-1" id="user-menu-item-0">Your Profile</a>

            <a href="/" class="block px-4 py-2 text-sm text-gray-700" role="menuitem" tabindex="-1" id="user-menu-item-1">Settings</a>

            <a href="/" class="block px-4 py-2 text-sm text-gray-700" role="menuitem" tabindex="-1" id="user-menu-item-2">Sign out</a>
        </div>
    {/if}
</div>


<!-- Profile dropdown -->
<!--<div class="ml-3 relative" use:clickOutside={handleOutsideClick}>-->
<!--    <div class="flex">-->
<!--        {#if $user.signed_in}-->
<!--        <button-->
<!--            on:click={() => show = !show}-->
<!--            class="max-w-xs flex items-center text-sm rounded-full focus:outline-none focus:shadow-outline" id="user-menu" aria-label="User menu" aria-haspopup="true">-->
<!--            <img class="h-8 w-8 rounded-full" src="{$user.networkers.img}" alt="">-->
<!--        </button>-->
<!--        {:else if $user.fetching}-->
<!--            <p>Fetching!</p>-->
<!--        {:else}-->
<!--            <button on:click={() => navigateTo($user, 'register')} class="flex justify-center py-2 px-4 mr-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">Sign Up</button>-->
<!--            <button on:click={() => navigateTo($user, 'login')} class="flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500">Login</button>-->
<!--        {/if}-->
<!--    </div>-->
    <!--
      Profile dropdown panel, show/hide based on dropdown state.

      Entering: "transition ease-out duration-100"
        From: "transform opacity-0 scale-95"
        To: "transform opacity-100 scale-100"
      Leaving: "transition ease-in duration-75"
        From: "transform opacity-100 scale-100"
        To: "transform opacity-0 scale-95"
    -->
<!--    {#if show}-->
<!--        {#if $user.signed_in}-->
<!--            <div in:fadeScale={{duration: 100, easing: cubicIn, base_scale: 0.75}}-->
<!--                 out:fadeScale={{duration: 100, easing:cubicOut, base_scale: 0.75}}-->
<!--                 class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg">-->
<!--                <div class="py-1 rounded-md bg-white shadow-xs" role="menu" aria-orientation="vertical" aria-labelledby="user-menu">-->
<!--                    <a href="#foo" on:click|preventDefault={() => navigateTo($user, 'user-edit')} class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition ease-in-out duration-150" role="menuitem">Edit Profile</a>-->
<!--&lt;!&ndash;                    <a href="#foo" class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition ease-in-out duration-150" role="menuitem">Settings</a>&ndash;&gt;-->
<!--                    <a href="#foo" on:click|preventDefault={doLogout} class="block px-4 py-2 text-sm text-gray-700 hover:bg-gray-100 transition ease-in-out duration-150" role="menuitem">Sign out</a>-->
<!--                </div>-->
<!--            </div>-->
<!--        {/if}-->
<!--    {/if}-->
<!--</div>-->


<style>

</style>